import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Order } from '../../../Models/order';
import { ContactDto } from '../../../dtos/contact-dto';
import { ApiService } from '../../../core/services/api.service';
import { Contact } from '../../../Models/contact';

@Component({
    selector: 'dialog-show-contacts',
    templateUrl: './dialog-show-contacts.component.html',
    styleUrls: ['./dialog-show-contacts.component.scss']
})

export class DialogShowContactsComponent {

  contacts: ContactDto[] = [];
  idVehicle: number;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogShowContactsComponent>,
    private apiService: ApiService) {
    this.idVehicle = data;
    this.getContacts();
  }


  getContacts() {
    this.apiService.get('api/order/getContactsOrder/' + this.idVehicle.toString()).subscribe(response => {
      if (response.data) {
        this.contacts = response.data;
      }
    });
  }
}
